import { render, staticRenderFns } from "./TeamForm.vue?vue&type=template&id=f496b744&scoped=true"
import script from "./TeamForm.vue?vue&type=script&lang=js"
export * from "./TeamForm.vue?vue&type=script&lang=js"
import style0 from "./TeamForm.vue?vue&type=style&index=0&id=f496b744&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f496b744",
  null
  
)

export default component.exports